import React, {
  Fragment, useState,
} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Popconfirm,
  Tooltip,
} from 'antd';
import {
  SettingOutlined, DeleteOutlined, LoadingOutlined, ReloadOutlined,
} from '@ant-design/icons';
import Success from '@Images/admin/success.png';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import H3Text from '@Uilib/h3Text';
import '../../../../../scss/integration.scss';
import './style.scss';

/**
 *
 */
const TallyConnectionList = ({
  user, getTallyConnectionsLoading, history, tallyConnections, refreshTallyConnectionsLoading, deleteTallyConnection, refreshTallyConnections, callback,
}) => {
  const hasActiveConnection = tallyConnections?.find((connection) => connection?.company_details && connection?.company_details && connection?.locations);
  const [selectedRefreshItemId, setSelectedRefreshItemId] = useState(null);
  return (
    <div className="integration-connections__wrapper">
      {
        !getTallyConnectionsLoading && tallyConnections ? (
          <Fragment>
            {tallyConnections?.filter((item) => item)?.map((item) => (
              <Fragment key={item?.it_id}>
                <div className={`integration-card ${(item?.is_active === false && tallyConnections?.find((rec) => rec.is_active)) ? 'integration-card' : ''}`}>
                  <div className="integration-card-spacing">
                    {hasActiveConnection ? (
                      <Fragment>
                        <div className="integration-card-header">
                          <p>
                            {item?.company_details?.name}
                          </p>
                          {item?.is_active && <img src={Success} alt="" className="integration-card-header__img" />}
                        </div>
                        <H3Text text={`${item?.locations?.length || 0} ${item?.locations?.length > 1 ? 'Branches' : 'Branch'}`} className="integration-card-link" />
                        {(() => {
                          const tenants = item?.tenant?.filter((rec) => rec.it_id === item?.it_id) || [];
                          const firstTenant = tenants[0];
                          const remainingTenants = tenants.slice(1);
                          const remainingCount = remainingTenants.length;

                          return (
                            <div>
                              <Tooltip
                                title={
                                  remainingCount > 0 ? (
                                    <div className="tally-locations-tooltip">
                                      {remainingTenants?.map((tenant, index) => (
                                        <div key={index}>
                                          {tenant.tenant_name}
                                          {' '}
                                          -
                                          {' '}
                                          {tenant.tally_location_name}
                                        </div>
                                      ))}
                                    </div>
                                  ) : (
                                    <div className="tally-locations-tooltip">
                                      No additional tenants
                                    </div>
                                  )
                                }
                                placement="top"
                                overlayInnerStyle={{ background: 'white', color: 'black' }}
                              >
                                <span className="integration-card-link">
                                  {firstTenant ? `${firstTenant.tenant_name} - ${firstTenant.tally_location_name}` : ''}
                                  {remainingCount > 1 && ` +${remainingCount} more`}
                                </span>
                              </Tooltip>
                            </div>
                          );
                        })()}

                        <H3Text text={item?.license_info?.tallyversion} className="integration-card-detail" />
                      </Fragment>
                    ) : (
                      <div style={{ marginTop: '5%' }}>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'column',
                          textAlign: 'center',
                        }}
                        >
                          <div>
                            Establishing connection with your tally account...
                          </div>
                          <div>
                            <LoadingOutlined />
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="integration-card-footer">
                      {hasActiveConnection ? (
                        <Fragment>
                          <Popconfirm
                            placement="topRight"
                            disabled={refreshTallyConnectionsLoading}
                            title="Are you sure you want to delete this connection?"
                            onConfirm={() => {
                              const payload = {
                                org_id: user?.tenant_info?.org_id,
                                it_id: item?.it_id,
                              };
                              deleteTallyConnection(payload, () => {
                                history.push('/admin/integration/');
                                callback();
                              });
                            }}
                            okText="Yes"
                            cancelText="No"
                          >
                            <div className="icon-button icon-button-danger">
                              <DeleteOutlined />
                            </div>
                          </Popconfirm>
                          &nbsp;
                          <div
                            className="icon-button icon-button-primary"
                            onClick={() => {
                              if (refreshTallyConnectionsLoading && selectedRefreshItemId === item?.it_id) {
                                // still reloading
                              } else {
                                setSelectedRefreshItemId(item?.it_id);
                                refreshTallyConnections({
                                  it_id: item?.it_id,
                                }, () => {
                                  setSelectedRefreshItemId(null);
                                });
                              }
                            }}
                          >
                            {(refreshTallyConnectionsLoading && selectedRefreshItemId === item?.it_id) ? <LoadingOutlined /> : <ReloadOutlined />}
                          </div>
                          &nbsp;
                          <div
                            className="icon-button icon-button-primary"
                            onClick={() => {
                              history.push(`/admin/integration/tally/setup?it_id=${item?.it_id}`);
                            }}
                          >
                            <SettingOutlined />
                          </div>
                        </Fragment>
                      ) : (
                        <div />
                      )}
                      {!hasActiveConnection && (
                        <div
                          className="integration-card-footer"
                          style={{ marginBottom: '10px' }}
                        >
                          <Popconfirm
                            placement="topRight"
                            disabled={refreshTallyConnectionsLoading}
                            title="Are you sure you want to delete this connection?"
                            onConfirm={() => {
                              const payload = {
                                org_id: user?.tenant_info?.org_id,
                                it_id: item?.it_id,
                              };
                              deleteTallyConnection(payload, () => {
                                history.push('/admin/integration/');
                                callback();
                              });
                            }}
                            okText="Yes"
                            cancelText="No"
                          >
                            <div className="icon-button icon-button-danger">
                              <DeleteOutlined />
                            </div>
                          </Popconfirm>
                        </div>
                      )}
                    </div>

                  </div>
                </div>
              </Fragment>
            ))}
          </Fragment>
        ) : (
          <Fragment>
            <div className="integration-card__loading">
              <div className="integration-card-spacing">
                <div className="integration-card-header ">
                  <div className="loadingBlock integration-card__loading__header-text" />
                  <div className="loadingBlock integration-card__loading__header-image"> </div>
                </div>
                <div className="loadingBlock integration-card__loading__link"> </div>
                <div className="integration-card-footer">
                  <div className="loadingBlock integration-card__loading__footer" />
                </div>
              </div>
            </div>
          </Fragment>
        )
      }
    </div>
  );
};

const mapStateToProps = ({ UserReducers, TallyIntegrationReducers }) => ({
  user: UserReducers.user,
  tallyConnections: TallyIntegrationReducers.tallyConnections,
  deleteTallyConnectionLoading: TallyIntegrationReducers.deleteTallyConnectionLoading,
  refreshTallyConnectionsLoading: TallyIntegrationReducers.refreshTallyConnectionsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  deleteTallyConnection: (payload, callback) => dispatch(TallyIntegrationActions.deleteTallyConnection(payload, callback)),
  getTallyConnections: (orgId, callback) => dispatch(TallyIntegrationActions.getTallyConnections(orgId, callback)),
  refreshTallyConnections: (payload, callback) => dispatch(TallyIntegrationActions.refreshTallyConnections(payload, callback)),
});
TallyConnectionList.propTypes = {
  user: PropTypes.any,
  callback: PropTypes.any,
  tallyConnections: PropTypes.any,
  getTallyConnectionsLoading: PropTypes.bool,
  refreshTallyConnectionsLoading: PropTypes.bool,
  history: PropTypes.any,
  deleteTallyConnection: PropTypes.bool,
  getTallyConnections: PropTypes.func,
  refreshTallyConnections: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TallyConnectionList));
